module.exports = __webpack_public_path__ + "static/img/logo-bigger.f2b0807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-bigger.png
// module id = T/Oc
// module chunks = 1